import FormInputGroup from "../../../../../../packages/design-system/src/FormInputGroup";
import FormInput from "../../../../../../packages/design-system/src/FormInput";
import FormInputAffix from "../../../../../../packages/design-system/src/FormInputAffix";
import * as React from 'react';
export default {
  FormInputGroup,
  FormInput,
  FormInputAffix,
  React
};